import { billOverviewConstants } from '../constants';

export function billOverviewReducers(state = {}, action) {
    switch (action.type) {
            
        // Get Specific Invoice Details
        
        case billOverviewConstants.getSpecificInvoiceDetails_request:
            return {
                ...state,
                getSpecificInvoiceDetails_requesting: true, getSpecificInvoiceDetails_status: false,
            }
        case billOverviewConstants.getSpecificInvoiceDetails_success:
            return {
                ...state,
                getSpecificInvoiceDetails_requesting: false, getSpecificInvoiceDetails_status: true,
                specificInvoiceDetails: action.details.data
            }
        case billOverviewConstants.getSpecificInvoiceDetails_failure:
            return {
                ...state,
                getSpecificInvoiceDetails_requesting: false, getSpecificInvoiceDetails_status: false, 
            }

        default:
            return state;
    }
}